<template>
  <div class="main-cont container">
    <h4 class="title">Your Orders</h4>
    <hr />
    <div class="ord">
      <div class="ord-hdr">
        <div class="row gen-row">
          <div class="col-sm-3">
            <div class="">
              <span>ORDER PLACED</span>
            </div>
            <div class="">
              <span>August 31, 2020</span>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="">
              <span>TOTAL</span>
            </div>
            <div class="">
              <span>$10.50</span>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="">
              <span>SHIP TO</span>
            </div>
            <div class="">
              <a src="#">DJ Karimov</a>
            </div>
          </div>
          <div class="col-sm-4">
            <div>Booking#</div>
          </div>
        </div>
      </div>
      <div class="ord-main">
        <div class="row ">
          <div class="col-sm-8">
            <div class="row gen-row">
              <h6>Arriving Tomorrow by <time>9pm</time></h6>
            </div>
            <div class="row gen-row">
              <div class="col-sm-2 prds-info">
                <img class="sample" src="../../assets/amd.jpg" alt="" />
              </div>
              <div class="col-sm-10 ">
                <div class="row ">
                  <a href="#">
                    Info about product and the link which takes user back to
                    product.
                  </a>
                </div>
                <div class="row ">
                  <span> Sold by: <a href="#">GixCore</a> </span>
                </div>
                <div class="row">
                  <span>
                    $120.00
                  </span>
                </div>
                <div class="row">
                  <button class="gc-button ord-btn-2">Buy it again</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 pos">
            <button class="gc-button ord-btn-1">Track Package</button>
            <!-- <button class="gc-button ord-btn-1">Buy it Again</button> -->
            <button class="gc-button ord-btn-1">Return Item</button>
            <button class="gc-button ord-btn-1">Write a review</button>
            <button class="gc-button ord-btn-1">Contact Seller</button>
            <button class="gc-button ord-btn-1">Ask Question</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store          from "../../store";
export default {
  name: "YourOrders",

  data() {
    return {
      data:       {},
      first_name: "",
      last_name:  "",
      img_url:    "",
      edit:       false,
    };
  },
  methods: {
    handleUpdateForm() {
      console.log(this.getUser);
      this.refreshFields();
      store.dispatch("update", this.data);
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  created() {
    this.data = {
      email: this.email,
      username: this.username,
      first_name: this.first_name,
      last_name: this.last_name,
      img_url: this.img_url,
    };
    console.log(this.getUser);
    console.log(this.data);
  },
};
</script>

<style scoped>
@import "../../assets/css/dashboard.css";

.title {
  text-align: center;
}
.sample {
  width: 60px;
  height: 90px;
  margin-top: 0.4rem;
}
hr {
  border-top: 1px solid #434857;
}
.ord-hdr {
  border: 1px solid #434857;
}
.ord-main {
  border: 1px solid #434857;
  padding: 1.5rem;
}
.gen-row {
  margin: 0.5rem 0 0.5rem 0;
}
.prds-info {
  display: inline;
}
.ord-btn-1 {
  width: 11rem;
  height: 1.8rem;
  padding: 0;
}
.ord-btn-2 {
  width: 8rem;
  height: 1.8rem;
  padding: 0;
}
.pos {
  display: inline;
  text-align: center;
}
</style>